import React, { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import Placeholder from '../../../../shared/Placeholder';
import Card from '../../../../shared/Card';
import DeleteSegment from './DeleteSegment.jsx';
import { useGetPopulationSegments, deleteSegment } from '../../data';
import {
  Table,
  Tr,
  Th,
  ShadedTr,
  Td,
  Paragraph,
  ThContentWrapperRight,
  TdRight,
} from '../../../../shared/TableComponents/StyledComponents';
import Modal from '../../../../shared/Modal';

const DeleteButton = styled.i`
  margin-bottom: 4px;
  margin-left: 4px;
  cursor: pointer;
`;

const SegmentsTable = ({ data }) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(deleteSegment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['populationSegments']);
      Swal.close();
    },
  });

  const showModal = useCallback(
    segmentId => () => {
      Modal({
        component: (
          <DeleteSegment
            onCancel={() => Swal.clickCancel()}
            onConfirm={() => mutate({ segmentId })}
            title="Confirm Deletion"
          />
        ),
        showConfirmButton: false,
        width: '394px',
        padding: '24px',
      });
    },
    [mutate],
  );

  return (
    <React.Fragment>
      <Table>
        <colgroup>
          <col span="1" style={{ width: '10%' }}></col>
          <col span="1" style={{ width: '70%' }}></col>
          <col span="1" style={{ width: '10%' }}></col>
          <col span="1" style={{ width: '10%' }}></col>
        </colgroup>
        <thead>
          <Tr>
            <Th>ID</Th>
            <Th>Name</Th>
            <Th>
              <ThContentWrapperRight>User Count</ThContentWrapperRight>
            </Th>
            <Th></Th>
          </Tr>
        </thead>
        <tbody>
          {data.map((row, i) => {
            return (
              <ShadedTr key={i}>
                <Td>
                  <Paragraph>{row.id}</Paragraph>
                </Td>
                <Td>
                  <Paragraph>{row.name}</Paragraph>
                </Td>
                <TdRight>{row.user_count}</TdRight>
                <TdRight>
                  <DeleteButton
                    className="fa-regular fa-trash fa-lg"
                    onClick={showModal(row.id)}
                  />
                </TdRight>
              </ShadedTr>
            );
          })}
        </tbody>
      </Table>
    </React.Fragment>
  );
};

export const PopulationSegmentsTable = ({ onClick }) => {
  const { isLoading, data = { data: [] } } = useGetPopulationSegments();

  return (
    <Card title="Population Segments" onClick={onClick} isLoading={isLoading}>
      {data.length ? <SegmentsTable data={data} /> : <Placeholder />}
    </Card>
  );
};
